export const LogoMark = ({ size = 36 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    aria-hidden="true"
    className="shrink-0"
  >
    <rect width="100" height="100" rx="22" fill="#0E0C0B" stroke="rgba(245,242,235,0.18)" strokeWidth="2" />
    <g fill="#E05A47">
      <rect x="31" y="27" width="8" height="46" />
      <rect x="31" y="65" width="18" height="8" />
      <rect x="61" y="27" width="8" height="46" />
      <rect x="51" y="27" width="18" height="8" />
      <polygon points="31,27 40.5,27 69,73 59.5,73" />
    </g>
  </svg>
);

export const Logo = ({ onClick = null }) => {
  const handle = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick("#top");
    }
  };
  return (
    <a
      href="#top"
      onClick={handle}
      data-testid="navbar-logo"
      className="flex items-center gap-3 transition-opacity duration-300 hover:opacity-80"
      aria-label="Nex Studio Design — home"
    >
      <LogoMark />
      <span className="flex flex-col leading-none">
        <span className="font-serif text-xl tracking-tight text-bone">
          Nex<span className="text-terracotta">.</span>
        </span>
        <span className="mt-1 font-accent text-[9px] uppercase tracking-[0.38em] text-stone">
          Studio Design
        </span>
      </span>
    </a>
  );
};

export default Logo;